<template>
  <AlertBanner
    v-if="showRegisterMessage"
    type="info"
    :message="$t('We have sent a confirmation email. Check your inbox to activate your account.')"
  />
  <main class="relative">
    <LoginForm @login-success="onLoginSuccess" @go-to-register="goToRegister" />
  </main>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import LoginForm from "@/components/auth/LoginForm.vue";
import AlertBanner from "@/components/feedback/AlertBanner.vue";

const router = useRouter();
const route = useRoute();

const showRegisterMessage = computed(() => route.query.registered === "true");

const onLoginSuccess = () => {
  const redirectTarget =
    typeof route.query.redirect === "string" ? route.query.redirect : "/";
  router.push(redirectTarget).catch(() => null);
};

const goToRegister = () => {
  router.push("/register").catch(() => null);
};
</script>
